import DoneIcon from '@mui/icons-material/Done';
import SyncIcon from '@mui/icons-material/Sync';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box } from '@mui/material';

const STATUS_CONFIG = {
  ongoing: {
    label: 'Pending',
    icon: SyncIcon,
    sx: {
      backgroundColor: 'gx.actionBarButtonTile'
    }
  },
  finished: {
    label: 'Completed',
    icon: DoneIcon,
    sx: {
      backgroundColor: 'rgba(0, 230, 118, 0.10)',
      color: 'success.main'
    }
  },
  failed: {
    label: 'Failed',
    icon: WarningAmberIcon,
    sx: {
      backgroundColor: 'rgba(255, 23, 68, 0.10)',
      color: 'error.main'
    }
  }
} as const;

export const Status = ({ status }: { status: keyof typeof STATUS_CONFIG }) => {
  const { label, icon: Icon, sx } = STATUS_CONFIG[status];

  return (
    <Box
      sx={theme => ({
        gap: 0.5,
        display: 'flex',
        alignItems: 'center',
        fontSize: theme.typography.pxToRem(14),
        px: 2,
        height: 30,
        width: 123,
        justifyContent: 'center',
        ...sx
      })}
    >
      <Icon sx={theme => ({ fontSize: theme.typography.pxToRem(16) })} />
      {label}
    </Box>
  );
};
